__turbopack_context__.v({
  "social-icons": "social-network-links-module__drPw3q__social-icons",
  "socialLink": "social-network-links-module__drPw3q__socialLink",
});
